/**
 * Business Unit Color Theme Utility
 *
 * Maps Business Unit codes to Dolder brand colors for the BAB report.
 * Colors match the official Dolder Group brand guidelines.
 * (Copied 1:1 from bab-process-app-v2.)
 */

export interface BuTheme {
    /** Primary brand color hex */
    primary: string;
    /** Light background for running total rows */
    bgLight: string;
    /** Full-color background for KPI accent rows (Gross Profit, CM I, CM II, EAIBT) */
    bgAccent: string;
    /** Text color on accent background */
    textOnAccent: string;
    /** Accent text color on light backgrounds */
    textAccent: string;
}

const BU_THEMES: Record<string, BuTheme> = {
    ALL: {
        primary: '#4ea03e',
        bgLight: 'bg-green-50',
        bgAccent: 'bg-[#4ea03e]',
        textOnAccent: 'text-white',
        textAccent: 'text-green-800',
    },
    PLA: {
        primary: '#ffcc00',
        bgLight: 'bg-yellow-50',
        bgAccent: 'bg-[#ffcc00]',
        textOnAccent: 'text-gray-900',
        textAccent: 'text-yellow-800',
    },
    SPC: {
        primary: '#d4004c',
        bgLight: 'bg-rose-50',
        bgAccent: 'bg-[#d4004c]',
        textOnAccent: 'text-white',
        textAccent: 'text-rose-800',
    },
    'F&P': {
        primary: '#38aadc',
        bgLight: 'bg-sky-50',
        bgAccent: 'bg-[#38aadc]',
        textOnAccent: 'text-white',
        textAccent: 'text-sky-800',
    },
};

export function getBuTheme(buCode: string): BuTheme {
    return BU_THEMES[buCode] || BU_THEMES.ALL;
}

/** Source company code to display name mapping */
export const COMPANY_NAMES: Record<string, string> = {
    dch: 'Dolder Switzerland',
    dbi: 'Dolder Bigler AG',
    dit: 'Dolder Italia',
    dsp: 'Dolder Espana',
    dtr: 'Dolder Turkey',
    dfr: 'Eneco',
    bin: 'Bigler International',
    dat: 'Dolder Austria',
    dde: 'Dolder-Bigler Germany',
    dpt: 'Dolder Portugal',
};

/** Format a company code as "Company Name (CODE)" */
export function formatCompanyLabel(code: string): string {
    const name = COMPANY_NAMES[code];
    return name ? `${name} (${code.toUpperCase()})` : code.toUpperCase();
}
